module.exports = __webpack_public_path__ + "img/kasikorn-bank.7b1bd273.png";